"use client";
import Image from "next/image";
import loadingModalIcon from "@icons/loading-modal/loading-logo.svg";
import { Modal } from "../Modal";
import { useLoaderContent } from "./useLoaderContent";
import { DialogDescription, DialogTitle } from "../ui/dialog";
import { useLoading } from "@/hooks/useLoading";
import { useAppContext } from "@/app/context/AppProvider";

export function Loader() {
  const { isLoading } = useLoading();
  const { state } = useAppContext();
  const content = useLoaderContent(isLoading);

  const title = state.customModalContent?.title ? state.customModalContent?.title : content.title;
  const subText = state.customModalContent?.subText ? state.customModalContent?.subText : content.subText;

  return (
    <Modal isOpen={isLoading} variant="loading" hideDialogueTitle={false} showClose={false} removeOverflow={false}>
      <output className="flex flex-col justify-between items-center pt-8 pb-10 w-full" aria-atomic="true">
        <DialogTitle
          className="mb-4 max-w-[28.5rem] text-[40px] text-mondelez-primary-purple text-center uppercase leading-[40px] tracking-[0.4px]"
          tabIndex={0}
        >
          {title}
        </DialogTitle>
        <DialogDescription
          className="opacity-80 text-base mb-12 max-w-[25.87rem] text-mondelez-primary-purple text-center leading-[26px] tracking-[-0.32px]"
          tabIndex={0}
          aria-live="polite"
        >
          {subText}
        </DialogDescription>
        <div className="flex space-x-4 mt-auto" aria-hidden="true">
          {[0, 1, 2].map((index) => (
            <div key={index} className="animate-fade-in-out" style={{ animationDelay: `${index * 0.5}s` }}>
              <Image aria-hidden="true" src={loadingModalIcon} alt="loading-modal-icon" width={64} height={43} />
            </div>
          ))}
        </div>
      </output>
    </Modal>
  );
}
